import { useMatchDevice } from '@avensia/excite';
import { useLayout } from '../layout';

export function useImagePreset(): Excite.ContentApi.ImagePreset {
  const deviceMatch = useMatchDevice();
  const { layout, contentWidthInPx } = useLayout();
  if (deviceMatch.isTablet) {
    return 'small';
  } else if (deviceMatch.isLaptop || deviceMatch.isDesktop) {
    switch (layout) {
      case 'quarterQuarterHalf':
      case 'halfQuarterQuarter':
      case 'quarterHalfQuarter':
      case 'thirdThirdThird':
      case 'quarterQuarterQuarterQuarter':
        return 'small';
    }
    if ((contentWidthInPx && contentWidthInPx < 1400) || deviceMatch.isLaptop) {
      return 'medium';
    }
    return 'large';
  }

  return 'tiny';
}

export function useImageViewWidth() {
  const { layout, index, contentWidthInPx, mobileLayout } = useLayout();
  const position = index ? index + 1 : 1;
  const deviceMatch = useMatchDevice();
  if (deviceMatch.isDesktop || deviceMatch.isLaptop) {
    switch (layout) {
      case 'quarterQuarterHalf':
        return position <= 2 ? '25vw' : '40vw';
      case 'halfQuarterQuarter':
        return position === 1 ? '40vw' : '25vw';
      case 'quarterHalfQuarter':
        return position === 3 ? '40vw' : '25vw';
      case 'halfHalf':
        return contentWidthInPx && contentWidthInPx < 1400 ? '30vw' : '40vw';
      case 'quarterThreeQuarters':
        return position === 1 ? '60vw' : '25vw';
      case 'thirdTwoThirds':
        return position === 1 ? '25vw' : '40vw';
      case 'twoThirdsThird':
        return position === 1 ? '40vw' : '25vw';
      case 'thirdThirdThird':
        return '30vw';
      case 'quarterQuarterQuarterQuarter':
        return '25vw';
    }
  } else {
    if (mobileLayout === 'single') {
      return '100vw';
    }
    switch (layout) {
      case 'halfHalf':
        return mobileLayout === 'double' ? '40vw' : '100vw';
      case 'quarterQuarterQuarterQuarter':
        return '40vw';
      case 'quarterQuarterHalf':
        return position <= 2 ? '40vw' : '100vw';
      case 'halfQuarterQuarter':
        return position === 1 ? '100vw' : '40vw';
      case 'quarterHalfQuarter':
        return position === 2 ? '100vw' : '40vw';
    }
  }

  return undefined;
}

export const imageWidth: { [key: string]: number } = {
  ['thumb']: 180,
  ['tiny']: 360,
  ['small']: 680,
  ['medium']: 960,
  ['large']: 1250,
  ['extralarge']: 1440,
};
